import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

import App from './App.vue'

import { SidebarPlugin, ModalPlugin, AvatarPlugin, IconsPlugin } from 'bootstrap-vue'
import store from './store'

// phone form
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput)

Vue.mixin({store})

// Vue.extend({ i18n })
Vue.use(IconsPlugin)
Vue.use(AvatarPlugin)
Vue.use(SidebarPlugin)
Vue.use(ModalPlugin)
// Vue.use(CollapsePlugin)

const wrappedElement = wrap(Vue, App)

window.customElements.define("to-book-link", wrappedElement)
